export const EDUCATION_TEST_ACHIEVEMENTS = [];
